"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskViewModal = exports.TaskStatus = void 0;
const TaskStatus_yaml_component_1 = __importDefault(require("./TaskStatus.yaml?component"));
exports.TaskStatus = TaskStatus_yaml_component_1.default;
const TaskViewModal_yaml_component_1 = __importDefault(require("./TaskViewModal.yaml?component"));
exports.TaskViewModal = TaskViewModal_yaml_component_1.default;
